import React, {useEffect, useRef, useState} from "react";
import {
    Modal, Table, DefaultTablePagination, DatePicker, InputBox, notification, Popconfirm, Drawer
} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import _ from "lodash";
import moment from "moment";
import {editKotOfSaveOrderFxn, editOrderFxn, fetchAllOrder} from "./actions";
import {getItemLocalstorage, getVegStatus, PaymentType} from "../../components/_utils/_utils";
import {getOldKotByOrderIdFxn, getPrintProductsFxn, tableListFxn} from "../pos/actions";
import PrintDesign from "../print/printDesign";
import {useReactToPrint} from "react-to-print";
import {useDispatch} from "react-redux";
import {paymentGroupByPaymentMethodFxn, categorySalesSummaryFxn} from "../dashboard/action";
import {userListFxn} from "../userManager/actions";
import {removeAllKotsOfOrderFxn} from "./actions/index"
import Tooltip from "../../components/Elements/Tooltip";
import {UserRights} from "../../components/rightComponents";

const {confirm} = Modal;

function OrderList() {
    const userType = getItemLocalstorage("user")["userType"];
    const userId = getItemLocalstorage("user")["_id"];
    let dispatch = useDispatch();
    const componentRef = useRef();
    let tableRef = useRef();
    let [oldKots, setOldKots] = useState({
        total: 0, data: [],
    });
    let [isModalOpen, setIsModalOpen] = useState(false);
    let [isEditOrderModalOpen, setIsEditOrderModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("today");
    const [deletedProducts, setDeletedProducts] = useState([]);
    const [venueOptions, setVenueOptions] = useState([]);
    const [selectedPaymentInputs, setSelectedPaymentInputs] = useState([]);
    const [manualPaymentInputs, setManualPaymentInputs] = useState([]);
    const [selectedPaymentType, setSelectedPaymentType] = useState("");
    const [orderNoSearch, setOrderNoSearch] = useState('');
    const [newPaymentData, setNewPaymentData] = useState({
        cashAmount: 0,
        upiAmount: 0,
        cardAmount: 0,
    });
    const [selectedSummaryCategory, setSelectedSummaryCategory] = useState("");
    const [updateCustomerDrawer, setUpdateCustomerDrawer] = useState({
        visible: false,
        orderId: "",
    });

    const [updateCustomerForm, setUpdateCustomerForm] = useState({
        customerName: "",
        customerMobile: "",
        customerEmail: "",
        customerGst: "",
    });
    const [fullEditState, setFullEditState] = useState({
        orderId: "",
        visible: false
    })

    const openUpdateCustomerDrawer = (record) => {
        setUpdateCustomerDrawer({
            visible: true,
            orderId: record?._id || "",
        });

        setUpdateCustomerForm({
            customerName: record?.customerName || "",
            customerMobile: record?.customerMobile || "",
            customerEmail: record?.customerEmail || "",
            customerGst: record?.customerGst || "",
        });
    };

    const closeUpdateCustomerDrawer = () => {
        setUpdateCustomerDrawer({
            visible: false,
            orderId: "",
        });

        setUpdateCustomerForm({
            customerName: "",
            customerMobile: "",
            customerEmail: "",
            customerGst: "",
        });
    };

    const handleUpdateCustomerSubmit = () => {
        if (!updateCustomerForm.customerName) {
            notification.success({
                message: "Enter Customer Name",
            });
            return
        }
        if (!updateCustomerForm.customerMobile) {
            notification.success({
                message: "Enter Customer Mobile no",
            });
            return
        }

        try {
            const payload = {
                orderId: updateCustomerDrawer.orderId,
                customerName: updateCustomerForm.customerName || "",
                customerMobile: updateCustomerForm.customerMobile || "",
                customerEmail: updateCustomerForm.customerEmail || "",
                customerGst: updateCustomerForm.customerGst || "",
            };

            confirm({
                title: "Confirmation required",
                // description: " Are you sure you want to proceed? Once updated, these details cannot be changed again.",
                description: "Kindly confirm. Once submitted, the updated details will be locked permanently.",
                cancelText: "Cancel",
                submitText: "Submit",
                onSubmit: async () => {
                    const resp = await editOrderFxn(payload);
                    if (resp && resp.success) {
                        notification.success({
                            message: resp.message || "Customer updated successfully",
                        });
                        closeUpdateCustomerDrawer();

                        setTimeout(() => {
                            tableRef.current?.reload();
                            loadPaymentData();
                        }, 100);
                    } else {
                        notification.error({
                            message: resp.message || "Failed to update customer",
                        });
                    }
                }
            })
        } catch (error) {
            notification.error({
                message: "Something went wrong while updating customer",
            });
        }
    };

    let initPaymentMode = [{name: "Card", value: 0}, {name: "Cash", value: 0}, {name: "UPI", value: 0}, {
        name: "Total",
        value: 0
    }]
    const [paymentData, setPaymentData] = useState(initPaymentMode)
    const [categorySummaryData, setCategorySummaryData] = useState([]);
    const initialEditData = {
        totalAmount: 0,
        discount: 0,
        cgstAmount: 0,
        sgstAmount: 0,
        serviceTaxAmount: 0,
        netAmount: 0,
        cashDiscount: 0,
        finalAmount: 0,
        customerPaid: 0,
        cashAmount: 0,
        upiAmount: 0,
        cardAmount: 0,
    }
    const [orderData, setOrderData] = useState(initialEditData)
    const [orderNumber, setOrderNumber] = useState('')

    let [data, setData] = useState({
        orderNo: "",
        totalAmount: "",
        cgstAmount: "",
        sgstAmount: "",
        serviceTaxAmount: "",
        netAmount: "",
        orderId: "",
        discountPer: 0,
        serviceTaxIncluded: false,
    });
    const [dates, setDates] = useState({
        fromDate: '', toDate: '',
    });

    const handleDateTab = (key) => {
        setActiveTab(key);

        const today = new Date();
        let from, to;

        switch (key) {
            case "today":
                from = to = today;
                break;

            case "7days":
                from = new Date();
                from.setDate(today.getDate() - 7);
                to = today;
                break;

            case "1month":
                from = new Date();
                from.setMonth(today.getMonth() - 1);
                to = today;
                break;

            case "3months":
                from = new Date();
                from.setMonth(today.getMonth() - 3);
                to = today;
                break;

            case "custom":
                from = '';
                to = '';
                break;

            default:
                from = to = today;
        }

        setDates({fromDate: from, toDate: to});
    };

    let [singleOrderData, setSingleOrderData] = useState({});
    let [choosePaymentType, setChoosePaymentType] = useState("");
    let [orderId, setOrderId] = useState("");
    let [editKotModal, setEditKotModal] = useState(false);
    let [refreshView, setRefrestView] = useState(false);
    let [kotId, setKotId] = useState("");
    let [editKotProducts, setEditKotProducts] = useState([]);
    let [editdata, seteditData] = useState({});
    let [tableNo, setTableNo] = useState('');
    let [viewEditKot, setViewEdit] = useState(false);
    let [tableFilterData, setTableFilterData] = useState([]);
    let [tableName, setTableName] = useState('');
    let [userName, setUserName] = useState('');
    let [tableList, setTableList] = useState([])
    let [userList, setUsers] = useState([])
    // useEffect(() => {
    //     if (tableName) {
    //         let table = tableList.find(table => table.name == tableName);
    //         const keysArray = table.tables.map(item => item.key);
    //         setTableFilterData(keysArray)
    //     } else {
    //         setTableFilterData([])
    //     }
    // }, [tableName]);
    //new code
    useEffect(() => {
        if (tableName) {
            let table = tableList.find((item) => item.name === tableName);

            if (table) {
                const keysArray = table.tables.map((item) => item.key);
                setTableFilterData(keysArray);
                setSelectedSummaryCategory("");
            } else {
                setTableFilterData([]);
            }
        } else {
            setTableFilterData([]);
            setSelectedSummaryCategory("");
        }
    }, [tableName, tableList]);
    //new code
    useEffect(() => {
        if (kotId) {
            const kot = oldKots.data.find((kot) => kot._id == kotId);
            if (kot) {
                setEditKotProducts(kot.products);
                setTableNo(kot.tableNo)
            }
        }
    }, [kotId]);

    let events = {

        incEditQty: (data) => {
            let clonePro = _.clone(editKotProducts);
            let findPro = _.find(clonePro, (item) => {
                return (item.productId._id == data.productId._id && item.price == data.price);
            });
            if (findPro) {
                findPro.quantity = findPro.quantity + 1;
                findPro.totalAmount = findPro.quantity * parseFloat(findPro.price);
            }
            setEditKotProducts(clonePro);
        },

        // desEditcQty: (data) => {
        //     let clonePro = _.clone(editKotProducts);
        //     let findPro = _.find(clonePro, (item) => {
        //         return (
        //             item.productId._id == data.productId._id && item.price == data.price
        //         );
        //     });
        //     if (findPro) {
        //         findPro.quantity = findPro.quantity - 1;
        //         findPro.totalAmount = findPro.quantity * parseFloat(findPro.price);
        //     }
        //     if (findPro.quantity == 0) {
        //         editKotProducts = _.reject(clonePro, (item) => {
        //             return (
        //                 item.productId._id == data.productId._id && item.price == data.price
        //             );
        //         });
        //         setEditKotProducts(editKotProducts);
        //     } else {
        //         setEditKotProducts(clonePro);
        //     }
        // },
        //new code
        desEditcQty: (data) => {
            let clonePro = _.clone(editKotProducts);
            let findPro = _.find(clonePro, (item) => {
                return (item.productId._id == data.productId._id && item.price == data.price);
            });

            if (findPro) {
                findPro.quantity = findPro.quantity - 1;
                findPro.totalAmount = findPro.quantity * parseFloat(findPro.price);
            }

            if (findPro && findPro.quantity == 0) {
                let updatedProducts = _.reject(clonePro, (item) => {
                    return (item.productId._id == data.productId._id && item.price == data.price);
                });

                setDeletedProducts((prev) => [...prev, findPro]);
                setEditKotProducts(updatedProducts);
            } else {
                setEditKotProducts(clonePro);
            }
        },
    };
    //new code
    const removeSingleProduct = (product) => {
        let updatedProducts = _.reject(editKotProducts, (item) => {
            return (item.productId._id == product.productId._id && item.price == product.price);
        });

        setDeletedProducts((prev) => [...prev, product]);
        setEditKotProducts(updatedProducts);
    };
    const removeAllKotsFromOrder = async () => {
        let x = await dispatch(removeAllKotsOfOrderFxn({
            orderId: data.orderId
        }));

        if (x && x.success) {
            setDeletedProducts([]);
            setOldKots({
                total: 0, data: [],
            });
            setEditKotProducts([]);
            setKotId("");
            setEditKotModal(false);
            setIsModalOpen(false);
            tableRef.current.reload();
            loadPaymentData();
        }
    };
    //new code
    let handleEditkot = async (editKotProducts, kotSubmitType) => {
        editdata.products = editKotProducts;
        editdata.deletedProducts = deletedProducts;
        editdata.tableNo = tableNo;
        editdata.kotId = kotId;
        editdata.kotSubmitType = kotSubmitType;
        // editdata.serviceTaxIncluded = true;
        // editdata.orderId = data.orderId
        editdata.orderId = data.orderId;
        editdata.discountPer = data.discountPer || 0;
        editdata.serviceTaxIncluded = data.serviceTaxIncluded || false;
        let x = await dispatch(editKotOfSaveOrderFxn(editdata));
        if (x && x.success == true) {
            setDeletedProducts([]);
            getOldKotData()
            setEditKotModal(false)
            setIsModalOpen(false)
            tableRef.current.reload()
        }
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    let loadOrderData = async (orderId) => {
        let params = {orderId, count: 1000, results: 1000};
        let resp = await dispatch(getPrintProductsFxn(params));
        setSingleOrderData(resp);
    };

    let oldOrderData = async (orderId) => {
        let params = {orderId, count: 1000, results: 1000};
        let resp = await dispatch(getPrintProductsFxn(params));
        setOrderNumber(resp.orderNo)
        setOrderData({
            totalAmount: resp.totalAmount,
            discount: resp.discount,
            cgstAmount: resp.cgstAmount,
            sgstAmount: resp.sgstAmount,
            serviceTaxAmount: resp.serviceTaxAmount,
            netAmount: resp.netAmount,
            cashDiscount: resp.cashDiscount,
            finalAmount: resp.finalAmount,
            customerPaid: resp.customerPaid,
            cashAmount: resp.cashAmount,
            upiAmount: resp.upiAmount,
            cardAmount: resp.cardAmount,
        })
    };

    useEffect(() => {
        if (singleOrderData && singleOrderData._id) {
            handlePrint();
        }
    }, [singleOrderData]);

    const loadPaymentData = async (params = {}) => {
        if (dates.fromDate && dates.toDate) {
            params.fromDate = dates.fromDate
            params.toDate = dates.toDate
        }
        if (choosePaymentType) {
            params.paymentType = choosePaymentType
        }
        if (tableFilterData.length > 0) {
            params.tableNo = tableFilterData;
        }
        if (userName) {
            params.userId = userName;
        }
        if (selectedSummaryCategory) {
            params.summaryCategory = selectedSummaryCategory;
        }
        let finalArr = []
        const {data} = await paymentGroupByPaymentMethodFxn({...params});
        let cloneDoc = _.cloneDeep(initPaymentMode);
        _.each(cloneDoc, (item) => {
            let findVal = _.find(data, (doc) => {
                return doc._id == item.name.toLowerCase()
            })

            if (findVal) {
                finalArr.push({
                    name: item.name, value: findVal.totalAmount, ...findVal
                })
                // item.value = findVal.totalAmount
            }
        })
        const categoryResp = await categorySalesSummaryFxn({...params});
        setCategorySummaryData(categoryResp?.data || []);
        // new code
        setPaymentData(data)
    };

    useEffect(() => {
        loadPaymentData()
        loadTables()
        loadUsers()
    }, [])

    const getOldKotData = (params = {}) => {
        return new Promise(async (resolve) => {
            try {
                const {data: kotData, total} = await getOldKotByOrderIdFxn({
                    ...params, results: 1000, count: 1000, orderId: data.orderId,
                });
                if (kotData.total) {
                    setOldKots({
                        data: kotData.data, total: kotData.total,
                    });
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });
    };

    // const editOrder = () => {
    //     return new Promise(async () => {
    //         try {
    //             orderData.orderId = orderId
    //             orderData.updatedBy = userType
    //             orderData.updatedByUserId = userId
    //             orderData.setteledAmount = orderData.netAmount
    //             const editOrderData = await editOrderFxn({
    //                 ...orderData
    //             });
    //             if (editOrderData.success) {
    //                 notification.success({
    //                     message: editOrderData.message
    //                 })
    //                 setOrderData(initialEditData)
    //                 setIsEditOrderModalOpen(false)
    //                 tableRef.current.reload()
    //             } else {
    //                 notification.error({
    //                     message: editOrderData.message
    //                 })
    //             }
    //         } catch (error) {
    //             console.error("Error fetching data:", error);
    //         }
    //     });
    // };
    const editOrder = () => {
        return new Promise(async () => {
            try {
                // Get new payment amounts from modal
                const newCash = Number(newPaymentData.cashAmount) || 0;
                const newUpi = Number(newPaymentData.upiAmount) || 0;
                const newCard = Number(newPaymentData.cardAmount) || 0;
                const newTotalPaid = newCash + newUpi + newCard;

                const finalAmount = Number(orderData.finalAmount) || 0;

                // Validate new total matches final amount
                if (newTotalPaid !== finalAmount) {
                    notification.warning({
                        message: `Total payment (₹${newTotalPaid.toFixed(2)}) must equal Final Amount (₹${finalAmount.toFixed(2)})`
                    });
                    return;
                }

                if (newCash < 0 || newUpi < 0 || newCard < 0) {
                    notification.warning({message: "Payment amounts cannot be negative"});
                    return;
                }
                const loggedInUserName = getItemLocalstorage("user")["name"];
                const updatedData = {
                    ...orderData,
                    cashAmount: newCash,
                    upiAmount: newUpi,
                    cardAmount: newCard,
                    customerPaid: newTotalPaid,
                    orderId: orderId,
                    updatedBy: userType,
                    updatedByUserId: userId,
                    userName: loggedInUserName,
                    actionType: "PAYMENT_EDIT",
                    setteledAmount: orderData.netAmount
                };

                const editOrderData = await editOrderFxn(updatedData);

                if (editOrderData.success) {
                    notification.success({message: editOrderData.message});
                    setOrderData(initialEditData);
                    setNewPaymentData({cashAmount: 0, upiAmount: 0, cardAmount: 0});
                    setSelectedPaymentInputs([]);
                    setManualPaymentInputs([]);
                    setSelectedPaymentType("");
                    setIsEditOrderModalOpen(false);
                    tableRef.current.reload();
                    loadPaymentData();
                } else {
                    notification.error({message: editOrderData.message});
                }
            } catch (error) {
                console.error("Error editing order:", error);
                notification.error({message: "Something went wrong"});
            }
        });
    };
    const handleSubmitFullEdit = async () => {
        try {
            orderData.orderId = fullEditState.orderId
            orderData.updatedBy = userType
            orderData.updatedByUserId = userId
            orderData.setteledAmount = orderData.netAmount
            const editOrderData = await editOrderFxn({
                ...orderData
            });
            if (editOrderData.success) {
                notification.success({
                    message: editOrderData.message
                })
                setOrderData(initialEditData)
                tableRef.current.reload()
                setFullEditState({
                    orderId: "",
                    visible: false
                })
            } else {
                notification.error({
                    message: editOrderData.message
                })
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const handlePaymentOptionToggle = (type) => {
        let updatedInputs = [];

        if (selectedPaymentInputs.includes(type)) {
            updatedInputs = selectedPaymentInputs.filter((item) => item !== type);
            setManualPaymentInputs((prev) => prev.filter((item) => item !== type));
            setSelectedPaymentInputs(updatedInputs);
            setNewPaymentData((prev) => ({
                ...prev,
                [`${type}Amount`]: 0,
            }));
            return;
        }

        const total = Number(orderData.finalAmount || 0);
        const usedAmount = Number(newPaymentData.cashAmount || 0) + Number(newPaymentData.upiAmount || 0) + Number(newPaymentData.cardAmount || 0);
        const remaining = Math.max(total - usedAmount, 0);

        if (remaining <= 0) {
            notification.warning({
                message: "Full amount is already assigned.",
            });
            return;
        }

        updatedInputs = [...selectedPaymentInputs, type];
        setSelectedPaymentInputs(updatedInputs);
        setNewPaymentData((prev) => ({
            ...prev,
            [`${type}Amount`]: Number(remaining.toFixed(2)),
        }));
    };

    const handlePaymentInputChange = (type, value) => {
        let inputValue = Number(value || 0);
        const total = Number(orderData.finalAmount || 0);

        if (inputValue < 0) inputValue = 0;
        if (inputValue > total) inputValue = total;

        const updatedManualInputs = manualPaymentInputs.includes(type) ? manualPaymentInputs : [...manualPaymentInputs, type];
        setManualPaymentInputs(updatedManualInputs);

        let newData = {
            ...newPaymentData,
            [`${type}Amount`]: Number(inputValue.toFixed(2)),
        };

        const usedByManual = updatedManualInputs.reduce((sum, method) => {
            return sum + Number(newData[`${method}Amount`] || 0);
        }, 0);

        let remaining = Number((total - usedByManual).toFixed(2));
        if (remaining < 0) remaining = 0;

        const autoMethods = selectedPaymentInputs.filter((method) => !updatedManualInputs.includes(method));

        autoMethods.forEach((method, index) => {
            if (index === autoMethods.length - 1) {
                newData[`${method}Amount`] = Number(remaining.toFixed(2));
            } else {
                newData[`${method}Amount`] = 0;
            }
        });

        setNewPaymentData(newData);
    };
    useEffect(() => {
        getOldKotData();
    }, [data.orderId]);
    useEffect(() => {
        let venueArr = tableList.map((item) => ({
            label: item.name, value: item.name, type: "table"
        }));

        let summaryArr = categorySummaryData
            .filter((item) => item.categoryName) // safe check
            .map((item) => ({
                label: item.categoryName, value: item.categoryName, type: "summary"
            }));

        // remove duplicates by value
        let finalArr = _.uniqBy([...venueArr, ...summaryArr], "value");

        setVenueOptions(finalArr);
    }, [tableList, categorySummaryData]);

    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            try {
                if (dates.fromDate && dates.toDate) {
                    params.dayOpenDate = {
                        $gte: moment(dates.fromDate).startOf('day')._d, $lte: moment(dates.toDate).endOf('day')._d,
                    };
                }
                if (choosePaymentType) {
                    params.paymentType = choosePaymentType
                }
                params.status = {$in: ["Paid"]};
                // params.status = {$in: ["Done", "Paid"]};
                params.guest = false;
                // new code
                params.isComplementaryBill = {$ne: true};
                // params.isEdited = true;

                // new code
                // params.tableNo = {$not: {$regex: "g"}};
                if (orderNoSearch) {
                    params.orderNo = orderNoSearch;
                }
                if (tableFilterData.length > 0) {
                    params.tableNo = tableFilterData;
                }
                if (userName) {
                    params.userId = userName;
                }
                if (selectedSummaryCategory) {
                    params.summaryCategory = selectedSummaryCategory;
                }
                const data = await fetchAllOrder({...params});
                resolve(data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });
    };

    const refreshTable = () => {
        loadPaymentData()
        tableRef.current.reload();
    };
    const getStickyStyles = (left, width) => ({
        position: "sticky",
        left: `${left}px`,
        zIndex: 2,
        background: "#fff",
        minWidth: `${width}px`,
        maxWidth: `${width}px`,
        width: `${width}px`,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        boxSizing: "border-box",
    });

    const getStickyHeaderStyles = (left, width) => ({
        position: "sticky",
        left: `${left}px`,
        zIndex: 3,
        background: "#fff",
        minWidth: `${width}px`,
        maxWidth: `${width}px`,
        width: `${width}px`,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        boxSizing: "border-box",
    });

    const columns = [
        {
            title: "Sr. No", dataIndex: "serialNo", key: "serialNo",
            width: 60, onCell: () => ({
                style: getStickyStyles(0, 60),
            }), onHeaderCell: () => ({
                style: getStickyHeaderStyles(0, 60),
            }), render: (text, record, index) => index + 1,
        }, {
            title: "Status", dataIndex: "status", key: "status", width: 100, onCell: () => ({
                style: getStickyStyles(60, 100),
            }), onHeaderCell: () => ({
                style: getStickyHeaderStyles(60, 100),
            }), render: (item) => {
                return (<>
                    {item == "Pending" ? (<label className={"label label-warning label-style"}>
                        Pending
                    </label>) : ("")}
                    {item == "Paid" ? (<label className={"label label-success label-style"}>Paid</label>) : ("")}
                    {item == "Done" ? (<label className={"label label-primary label-style"}>Done</label>) : ("")}
                </>);
            },
        }, {
            title: "Table No.", dataIndex: "tableNo", key: "tableNo", width: 100, onCell: () => ({
                style: getStickyStyles(160, 100),
            }), onHeaderCell: () => ({
                style: getStickyHeaderStyles(160, 100),
            }),
        }, {
            title: "Order No.", dataIndex: "orderNo", key: "orderNo", width: 100, onCell: () => ({
                style: getStickyStyles(260, 100),
            }), onHeaderCell: () => ({
                style: getStickyHeaderStyles(260, 100),
            }),
        }, {
            title: "Table Name", dataIndex: "tableName", key: "tableName", width: 120, onCell: () => ({
                style: getStickyStyles(360, 120),
            }), onHeaderCell: () => ({
                style: getStickyHeaderStyles(360, 120),
            }),
        }, {
            title: "Day Open Date", dataIndex: "dayOpenDate", key: "dayOpenDate", width: 140, onCell: () => ({
                style: getStickyStyles(480, 140, true),
            }), onHeaderCell: () => ({
                style: getStickyHeaderStyles(480, 140, true),
            }),
            render: (text, record) => (<span>{text && moment(record.dayOpenDate).format("DD/MM/YYYY")} </span>),
        },
        {
            title: "Order Date & Time",
            dataIndex: "date",
            key: "date",
            render: (text, record) => (<span>{moment(record.date).format("DD/MM/YYYY, hh:mm A")} </span>),
        },
        //     {
        //     title: "Customer Name", dataIndex: "customerName", key: "customerName",
        // },
        {
            title: "Customer Name",
            dataIndex: "customerName",
            key: "customerName",
            render: (item, record) => {
                if (item) {
                    return item;
                }

                return (
                    <Tooltip title={"Update Customer"}>
                        <a className={'btn-link btn-xs'} style={{fontSize: 12}}
                           onClick={() => openUpdateCustomerDrawer(record)}>
                            Update Customer
                        </a>
                    </Tooltip>
                );
            },
        },
        {
            title: "Pax Number", dataIndex: "paxNumber", key: "paxNumber", render: (item) => {
                return item ? item : "-"
            }
        }, {
            title: "Total Amount", dataIndex: "totalAmount", key: "totalAmount",
        }, {
            title: "Discount", dataIndex: "discount", key: "discount",
        }, {
            title: "CGST Amount", dataIndex: "cgstAmount", key: "cgstAmount",
        }, {
            title: "SGST Amount", dataIndex: "sgstAmount", key: "sgstAmount",
        }, {
            title: "Service Charges", dataIndex: "serviceTaxAmount", key: "serviceTaxAmount",
        }, {
            title: "Net Amount", dataIndex: "netAmount", key: "netAmount",
        }, {
            title: "Cash Discount", dataIndex: "cashDiscount", key: "cashDiscount",
        }, {
            title: "Round of Amt.", dataIndex: "roundOfAmount", key: "roundOfAmount",
        }, {
            title: "Final Amount", dataIndex: "finalAmount", key: "finalAmount",
        }, {
            title: "Last Final Amount", dataIndex: "lastFinalAmount", key: "lastFinalAmount",
        }, {
            title: "customer Paid", dataIndex: "customerPaid", key: "customerPaid",
        }, {
            title: "Cash Amount", dataIndex: "cashAmount", key: "cashAmount",
        }, {
            title: "Upi Amount", dataIndex: "upiAmount", key: "upiAmount",
        }, {
            title: "Card Amount", dataIndex: "cardAmount", key: "cardAmount",
        },
        {
            title: "Taxable Amount",
            dataIndex: "taxableAmount",
            key: "taxableAmount",
            render: (val) => val ? val.toFixed(2) : "0.00"
        },
        {
            title: "Non-Taxable Amount",
            dataIndex: "nonTaxableAmount",
            key: "nonTaxableAmount",
            render: (val) => val ? val.toFixed(2) : "0.00"
        },
        {
            title: "Added By User",
            dataIndex: "userName",
            key: "userName",
            render: (item, record) => (item ? (item) : null),
        },
        {
            title: "Action", dataIndex: "action",
            fixed: "right",
            key: "action", render: (v, record) => {
                return (<>
                    {userType != 'cashier' && record.status && record.status !== "Pending" ? (
                        <div className={'d-flex gap-1'}>
                            <Tooltip title={'View KOT'}>
                                {/*   <a
                                className="empty_btn"
                                onClick={() => {
                                    setIsModalOpen(true);
                                    if (record) {
                                        setData({
                                            orderNo: record.orderNo,
                                            totalAmount: record.totalAmount,
                                            cgstAmount: record.cgstAmount,
                                            sgstAmount: record.sgstAmount,
                                            serviceTaxAmount: record.serviceTaxAmount,
                                            netAmount: record.netAmount,
                                            orderId: record._id,
                                            discountPer: record.discountPer,
                                            serviceTaxIncluded: record.serviceTaxIncluded || false,
                                        });
                                        if (record.cashAmount && record.cashAmount != 0 && !record.upiAmount && !record.cardAmount) {
                                            setViewEdit(true)
                                        }
                                    }
                                }}>
                                <i className={"fa fa-eye"}/>
                            </a>*/}
                                {/* ✅ Wrap View KOT with UserRights to restrict access to management */}
                                <UserRights
                                    user={getItemLocalstorage("user")}
                                    userTypes={['fbManager', 'admin',]}>
                                    <Tooltip title={'View KOT'}>
                                        <a className="btn btn-sm btn-warning rounded-3"
                                           onClick={() => {
                                               setIsModalOpen(true);
                                               if (record) {
                                                   setData({
                                                       orderNo: record.orderNo,
                                                       totalAmount: record.totalAmount,
                                                       cgstAmount: record.cgstAmount,
                                                       sgstAmount: record.sgstAmount,
                                                       serviceTaxAmount: record.serviceTaxAmount,
                                                       netAmount: record.netAmount,
                                                       orderId: record._id,
                                                       discountPer: record.discountPer,
                                                       discount: record.discount,
                                                       serviceTaxIncluded: record.serviceTaxIncluded || false,
                                                   });

                                                   // Allow editing KOT items only if it was a pure Cash bill (standard audit logic)
                                                   if (record.cashAmount && record.cashAmount != 0 && !record.upiAmount && !record.cardAmount) {
                                                       setViewEdit(true);
                                                   }
                                               }
                                           }}>
                                            <i className={"fa fa-eye"}/>
                                        </a>
                                    </Tooltip>
                                </UserRights>
                            </Tooltip>

                            <Tooltip title={'Print'}>
                                <a className="btn btn-sm btn-info rounded-3"
                                   onClick={() => {
                                       loadOrderData(record._id);
                                   }}>
                                    <i className={"fa fa-print"}/>
                                </a>
                            </Tooltip>
                            <UserRights
                                user={getItemLocalstorage("user")}
                                userTypes={['fbManager', 'admin']}>
                                <Tooltip title={'Edit Payment'}>
                                    <a className="btn btn-sm btn-success rounded-3"
                                       onClick={async () => {
                                           await oldOrderData(record._id);
                                           setOrderId(record._id);

                                           // Reset all payment states
                                           setNewPaymentData({cashAmount: 0, upiAmount: 0, cardAmount: 0});
                                           setSelectedPaymentInputs([]);
                                           setManualPaymentInputs([]);
                                           setSelectedPaymentType("");
                                           setIsEditOrderModalOpen(true);
                                       }}>
                                        <i className={"fa fa-edit"}/>
                                    </a>
                                </Tooltip>
                            </UserRights>
                        </div>) : ("")}


                    {/* <a className="empty_btn"
                       onClick={() => {
                           oldOrderData(record._id);
                           setFullEditState({
                               orderId: record._id,
                               visible: true
                           })
                       }}>
                        <i className={"fa fa-edit"}/>
                    </a>*/}

                </>);
            },
        },];

    const getColumns = () => {
        let columnArr = [];
        _.each(columns, (item) => {
            if (!item.hide) {
                columnArr.push(item);
            }
        });
        return columnArr;
    };

    let orderN = (<div>
        Order Number : {data.orderNo} | <small style={{fontSize: 13}}> (No of Kots - {oldKots.total}) </small>
    </div>);

    let fixedAmount = (amount) => {
        return amount ? `Rs. ${amount.toFixed(2)}` : 0
    }

    let loadTables = async () => {
        let {data} = await tableListFxn();
        let filteredData = data.filter(item => item.name.toLowerCase() !== 'hod' && item.name.toLowerCase() !== 'md' && item.name.toLowerCase() !== 'guest');
        setTableList(filteredData);
    }

    let loadUsers = async (params = {}) => {
        params.results = 200
        const {data} = await userListFxn({...params});
        setUsers(data);
    }

    return (<PageHeader title={"Order List"}>
        {/*{totalNetAmount}*/}

        <div className="card_grid order_container" key={paymentData ? JSON.stringify(paymentData) : "666"}>
            {/*{paymentData && paymentData.length ? paymentData.map((item) => {*/}
            {!selectedSummaryCategory && paymentData && paymentData.length ? paymentData.map((item) => {
                return (
                    <div key={item.name}>
                        <div
                            className="dash-widget"
                            style={{
                                borderRadius: 14,
                                padding: 14,
                                background: "#ffffff",
                                display: "flex",
                                gap: 12,
                                boxShadow: "0 3px 8px rgba(0,0,0,0.06)",
                                minWidth: "200px",
                            }}
                        >
                            {/* Content */}
                            <div style={{flex: 1}}>
                                <div className={'d-flex justify-content-between'}>
                                    <div className={'d-flex'}
                                         style={{fontSize: 16, fontWeight: 700, color: "#222"}}>
                                        <div
                                            style={{
                                                width: 35,
                                                height: 35,
                                                borderRadius: 12,
                                                background: "#eef3ff",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                marginRight: 5
                                            }}>
                                            <img src="assets/img/icons/dash1.svg" alt="img"
                                                 style={{width: 22, height: 22}}/>
                                        </div>
                                        <div className={'mt-2 ms-2'}>
                                            {item._id || "Total"}
                                        </div>
                                    </div>

                                    <div style={{fontSize: 20, fontWeight: 700, marginTop: 4, color: "#000"}}>
                                        ₹ {item.finalAmount ? item.finalAmount.toFixed(2) : "0.00"}
                                    </div>
                                </div>

                                {/* <div style={{
                                    fontSize: 12, fontWeight: 600, color: "#6c63ff", marginTop: 10
                                }}>
                                    Total Amount :-
                                </div>*/}

                                {/* Compact Sub Details */}
                                <div style={{
                                    fontSize: 11, marginTop: 8, color: "#444", fontWeight: 600, lineHeight: "16px"
                                }}>

                                    {/* Taxes Line */}
                                    <div className={'grid_3'}>
                                        <span>CGST: {fixedAmount(item.cgstAmount)}</span>
                                        <span>SGST: {fixedAmount(item.sgstAmount)}</span>
                                        <span>SRV: {fixedAmount(item.serviceTaxAmount)}</span>
                                    </div>
                                    <div className={'grid_2'}>
                                        <span>Taxable: {fixedAmount(item.taxableAmount)}</span>
                                        <span>Non-Taxable: {fixedAmount(item.nonTaxableAmount)}</span>
                                    </div>
                                    {/* Tip + Cash Discount */}
                                    <div className={'grid_3'}>
                                        {/*<span>Tip: {fixedAmount(item.tip)}</span>*/}
                                        <span>Cash Dis.: {fixedAmount(item.cashDiscount)}</span>
                                        <span>Dis.: {fixedAmount(item.discount)}</span>
                                        <span>Round Of.: {fixedAmount(item.roundOfAmount)}</span>

                                    </div>

                                    {/* Payments */}
                                    <div className={'grid_3'}>
                                        <span>Cash: {fixedAmount(item.cashAmount)}</span>
                                        <span>Card: {fixedAmount(item.cardAmount)}</span>
                                        <span>UPI: {fixedAmount(item.upiAmount)}</span>
                                    </div>
                                    <div style={{
                                        marginTop: '15px',
                                        padding: '10px',
                                        backgroundColor: '#f8f9fa',
                                        borderRadius: '8px',
                                        border: '1px solid #e9ecef',
                                        boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.02)'
                                    }}>
                                        <div style={{
                                            fontSize: '11px',
                                            fontWeight: 'bold',
                                            color: '#444',
                                            marginBottom: '6px',
                                            borderBottom: '1px solid #dee2e6',
                                            paddingBottom: '4px'
                                        }}>
                                            Audit Breakdown (Taxable / Non-Taxable)
                                        </div>

                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', fontWeight: '600' }}>
                                            <div style={{ color: '#007bff' }}>
                                                UPI<br/>
                                                T: {fixedAmount(item.upiTaxableAmount)}<br/>
                                                NT: {fixedAmount(item.upiNonTaxableAmount)}<br/>
                                                S: {fixedAmount(item.upiServiceTaxAmount)}
                                            </div>
                                            <div style={{ color: '#28a745' }}>
                                                CARD<br/>
                                                T: {fixedAmount(item.cardTaxableAmount)}<br/>
                                                NT: {fixedAmount(item.cardNonTaxableAmount)}<br/>
                                                S: {fixedAmount(item.cardServiceTaxAmount)}
                                            </div>
                                            <div style={{ color: '#ffc107' }}>
                                                CASH<br/>
                                                T: {fixedAmount(item.cashTaxableAmount)}<br/>
                                                NT: {fixedAmount(item.cashNonTaxableAmount)}<br/>
                                                S: {fixedAmount(item.cashServiceTaxAmount)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }) : null}
            {/*{paymentData && paymentData.length > 0 && (
                <div key="tax-summary">
                    <div className="dash-widget"
                         style={{
                             borderRadius: 14,
                             padding: 14,
                             background: "#ffffff",
                             display: "flex",
                             gap: 12,
                             boxShadow: "0 3px 8px rgba(0,0,0,0.06)",
                             minWidth: "200px",
                         }}>
                        <div style={{ flex: 1 }}>
                            <div className={'d-flex justify-content-between'}>
                                <div className={'d-flex'} style={{ fontSize: 16, fontWeight: 700, color: "#222" }}>
                                    <div style={{
                                        width: 35, height: 35, borderRadius: 12, background: "#eef3ff",
                                        display: "flex", alignItems: "center", justifyContent: "center", marginRight: 5
                                    }}>
                                        <img src="assets/img/icons/dash1.svg" alt="img" style={{ width: 22, height: 22 }} />
                                    </div>
                                    <div className={'mt-2 ms-2'}>Tax Summary</div>
                                </div>
                            </div>

                            <div style={{ fontSize: 12, fontWeight: 600, color: "#6c63ff", marginTop: 10 }}>
                                Breakdown :-
                            </div>

                            <div style={{ fontSize: 11, marginTop: 8, color: "#444", fontWeight: 600, lineHeight: "18px" }}>
                                <div className={'d-flex justify-content-between'}>
                                    <span>Taxable:</span>
                                    <span>₹ {(paymentData[paymentData.length - 1].taxableAmount || 0).toFixed(2)}</span>
                                </div>
                                <div className={'d-flex justify-content-between'}>
                                    <span>Non-Taxable:</span>
                                    <span>₹ {(paymentData[paymentData.length - 1].nonTaxableAmount || 0).toFixed(2)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}*/}

            {/*{categorySummaryData && categorySummaryData.length*/}
            {/*    ? categorySummaryData.map((item, index) => {*/}

            {categorySummaryData && categorySummaryData.length ? categorySummaryData.map((item, index) => {
                return (
                    <div key={item._id || index}>
                        <div
                            className="dash-widget"
                            style={{
                                borderRadius: 14,
                                padding: 14,
                                background: "#ffffff",
                                display: "flex",
                                gap: 12,
                                boxShadow: "0 3px 8px rgba(0,0,0,0.06)",
                                minWidth: "200px",
                            }}>
                            <div style={{flex: 1}}>
                                <div className={'d-flex justify-content-between'}>

                                    <div className={'d-flex'}
                                         style={{fontSize: 15, fontWeight: 700, color: "#222"}}>
                                        <div style={{
                                            width: 42,
                                            height: 42,
                                            borderRadius: 12,
                                            background: "#eef3ff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}>
                                            <img
                                                src="assets/img/icons/dash1.svg"
                                                alt="img"
                                                style={{width: 22, height: 22}}/>
                                        </div>
                                        <div className={'mt-2 ms-2'}>
                                            {item.mainCategory || `Category ${index + 1}`}
                                        </div>
                                    </div>

                                    <div style={{fontSize: 20, fontWeight: 700, marginTop: 4, color: "#000"}}>
                                        ₹ {(item.finalAmount || 0).toFixed(2)}
                                    </div>
                                </div>

                                <div style={{fontSize: 12, marginTop: 4, fontWeight: 600, color: "#6c63ff"}}>
                                    Total Amount
                                </div>

                                <div
                                    style={{
                                        fontSize: 11,
                                        marginTop: 8,
                                        color: "#444",
                                        fontWeight: 600,
                                        lineHeight: "16px",
                                    }}>
                                    <div className={'grid_3'}>
                                        <span>CGST: {fixedAmount(item.cgstAmount)}</span>
                                        <span>SGST: {fixedAmount(item.sgstAmount)}</span>
                                        <span>SRV: {fixedAmount(item.serviceTaxAmount)}</span>
                                    </div>

                                    <div className={'grid_2'}>
                                        {/*<span>Tip: {fixedAmount(item.tip)}</span>*/}
                                        <span>Cash Dis.: {fixedAmount(item.cashDiscount)}</span>
                                    </div>

                                    <div className={'grid_3'}>
                                        <span>Cash: {fixedAmount(item.cashAmount)}</span>
                                        <span>Card: {fixedAmount(item.cardAmount)}</span>
                                        <span>UPI: {fixedAmount(item.upiAmount)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>);
            }) : null}
        </div>

        <div className="row mb-3">

            {/* Date Range Tabs */}
            <div className="col-md-12 mb-3">
                <div className="btn-group">
                    {[{key: "today", label: "Today"}, {key: "7days", label: "Last 7 Days"}, {
                        key: "1month",
                        label: "Last Month"
                    }, {key: "3months", label: "Last 3 Months"}, {key: "custom", label: "Custom"},].map(tab => (
                        <button
                            key={tab.key}
                            className={`btn btn-outline-primary ${activeTab === tab.key ? 'activeDuration' : ''}`}
                            onClick={() => handleDateTab(tab.key)}
                        >
                            {tab.label}
                        </button>))}
                </div>
            </div>

            {/* Show DatePicker only when Custom is selected */}
            {activeTab == "custom" && (<>
                <div className="col-md-2">
                    <InputBox title={'From Date'}>
                        <DatePicker
                            value={dates.fromDate}
                            showClear={true}
                            placeholder={'Choose from Date'}
                            onChange={(value) => setDates({...dates, fromDate: value})}
                        />
                    </InputBox>
                </div>
                <div className="col-md-2">
                    <InputBox title={'To Date'}>
                        <DatePicker
                            value={dates.toDate}
                            showClear={true}
                            placeholder={'Choose to Date'}
                            onChange={(value) => setDates({...dates, toDate: value})}
                        />
                    </InputBox>
                </div>
            </>)}
            {/*Filters */}
            <div className="col-md-2">
                <InputBox title={'Order No.'}>
                    <input
                        className="form-control"
                        placeholder="Search Order No."
                        value={orderNoSearch}
                        onChange={(e) => setOrderNoSearch(e.target.value)}
                    />
                </InputBox>
            </div>

            <div className="col-md-2">
                <InputBox title={'Payment Type'}>
                    <select className="form-control search-filters"
                            onChange={(e) => setChoosePaymentType(e.target.value)}
                            value={choosePaymentType}
                    >
                        <option value={""}>Choose Payment Type</option>
                        {PaymentType.map((item) => (<option key={item.key} value={item.key}>
                            {item.name}
                        </option>))}
                    </select>
                </InputBox>
            </div>

            {/*<div className="col-md-2">*/}
            {/*    <InputBox title={'Choose Venue'}>*/}
            {/*        <select className="form-control search-filters"*/}
            {/*                onChange={(e) => setTableName(e.target.value)}*/}
            {/*                value={tableName}*/}
            {/*        >*/}
            {/*            <option value={""}>Choose Venue</option>*/}
            {/*            {tableList.map((item) => (*/}
            {/*                <option key={item.name} value={item.name}>*/}
            {/*                    {item.name}*/}
            {/*                </option>*/}
            {/*            ))}*/}
            {/*        </select>*/}
            {/*    </InputBox>*/}
            {/*</div>*/}
            <div className="col-md-2">
                <InputBox title={'Choose Venue'}>
                    <select
                        className="form-control search-filters"
                        onChange={(e) => {
                            const value = e.target.value;
                            setTableName(value);

                            const selectedOption = venueOptions.find((item) => item.value === value);

                            if (selectedOption?.type === "summary") {
                                setSelectedSummaryCategory(value);
                                setTableFilterData([]);
                            } else {
                                setSelectedSummaryCategory("");
                            }
                        }}
                        value={tableName}
                    >
                        <option value={""}>Choose Venue</option>
                        {venueOptions.map((item) => (<option key={`${item.type}-${item.value}`} value={item.value}>
                            {item.label}
                        </option>))}
                    </select>
                </InputBox>
            </div>


            <div className="col-md-2">
                <InputBox title={'Choose User'}>
                    <select className="form-control search-filters"
                            onChange={(e) => setUserName(e.target.value)}
                            value={userName}
                    >
                        <option value={""}>Choose User</option>
                        {userList.map((item) => (<option key={item._id} value={item._id}>
                            {item.name}
                        </option>))}
                    </select>
                </InputBox>
            </div>
            <div className="col-md-1 mt-4">
                <div className="search-wrap">
                    <button className="btn btn-info" onClick={refreshTable}>
                        Search
                    </button>
                </div>
            </div>
        </div>

        <div className="card mb-0">
            <div className="table-responsive" style={{overflow: "auto"}}>
                <Table
                    apiRequest={apiRequest}
                    columns={getColumns()}
                    pagination={DefaultTablePagination()}
                    ref={tableRef}
                    scroll={{x: 3500}}
                />
            </div>
        </div>

        {isModalOpen && (<Modal
            visible={isModalOpen}
            onClose={() => {
                setIsModalOpen(false);
                setViewEdit(false)
            }}
            title={orderN}
            width={'65%'}
        >
            <table key={refreshView} className="table table-bordered">
                <thead>
                <tr>
                    <td>Total Amount</td>
                    <td>Discount Amount</td>
                    <td>Cgst Amount</td>
                    <td>Sgst Amount</td>
                    <td>Service Charges</td>
                    <td>Net Amount</td>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{data.totalAmount}</td>
                    <td>{data.discount ? <span style={{color: "red"}}>{data.discount}</span> : "-"}</td>
                    <td>{data.cgstAmount}</td>
                    <td>{data.sgstAmount}</td>
                    <td>{data.serviceTaxAmount}</td>
                    <td>{data.netAmount}</td>
                </tr>
                </tbody>
            </table>
            <UserRights
                user={getItemLocalstorage("user")}
                userTypes={['admin', 'fbManager']}
            >
                <div className="d-flex justify-content-end mb-2">
                    <Popconfirm
                        title="Are you sure you want to remove all KOTs from this order?"
                        onConfirm={removeAllKotsFromOrder}
                        okText="Yes"
                        cancelText="No"
                    >
                        <button
                            type="button"
                            className="btn btn-danger btn-sm"
                        >
                            Delete All KOTs
                        </button>
                    </Popconfirm>
                </div>
            </UserRights>
            <div className={"mt-2"}>
                {oldKots && oldKots && oldKots.data.length ? oldKots.data.map((item, index) => {
                    return (<div key={item.kotNo}>
                        <div className="dark-background d-flex justify-content-between">
                            <h7>
                                Kot - {item.kotNo} Time -{" "}
                                {moment(item.time).format("hh:mm A")}
                            </h7>
                            <div>
                                {userType == "admin" && viewEditKot ? (<i
                                    className="fa fa-edit far"
                                    onClick={() => {
                                        setEditKotModal(true);
                                        setKotId(item._id);
                                    }}
                                />) : null}
                            </div>
                        </div>
                        {item.products.map((product) => {
                            return (<>
                                <ul
                                    className="product-lists mb-0 p-1"
                                    key={product._id}
                                >
                                    <li className="w-50">
                                        <div className="productimg">
                                            <div className="productcontet">
                                                <h4 className={"mb-0"}>
                                                    {product && product.productId && product.productId.vegNonVeg ? (<>
                                                        {getVegStatus(product.productId.vegNonVeg)}
                                                    </>) : ("")}
                                                    {product.name}{" "}
                                                    {product.variant && ` (${product.variant})`}

                                                </h4>

                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div style={{
                                            fontSize: 11,
                                            display: "flex",
                                            gap: 10,
                                            paddingRight: 50
                                        }}>
                                            <div>
                                                GST Allow :&nbsp;
                                                {product.gst ? <label className={'label label-success'}>YES</label> :
                                                    <label className={'label label-info'}>NO</label>}
                                            </div>
                                            <div>
                                                Discount Allow :
                                                <strong
                                                    style={{
                                                        color: product.gst ? '#28a745' : '#dc3545',
                                                        marginLeft: '4px'
                                                    }}>
                                                    {product.discount ?
                                                        <label className={'label label-success'}>YES</label> :
                                                        <label className={'label label-info'}>NO</label>}
                                                </strong>
                                            </div>
                                        </div>

                                    </li>
                                    <li>
                                        <div className="increment-decrement">
                                            <div className="input-groups">
                                                <h7>Qty:</h7>
                                                <input
                                                    type="text"
                                                    name="child"
                                                    value={product.quantity}
                                                    className="quantity-field"
                                                />
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div style={{fontSize: "80%"}}>
                                            Rs. {product.price}
                                        </div>
                                    </li>
                                    <li>
                                        <strong>Rs. {product.totalAmount}</strong>
                                    </li>
                                </ul>
                            </>);
                        })}
                    </div>);
                }) : null}
            </div>
        </Modal>)}
        {isEditOrderModalOpen && (
            <Modal
                visible={isEditOrderModalOpen}
                onClose={() => {
                    setIsEditOrderModalOpen(false);
                    setSelectedPaymentInputs([]);
                    setManualPaymentInputs([]);
                    setSelectedPaymentType("");
                    setNewPaymentData({cashAmount: 0, upiAmount: 0, cardAmount: 0});
                }}
                width={"35%"}
                title={`Edit Payment (Order No. - ${orderNumber})`}
            >
                {/* Final Amount */}
                <div className="mb-3">
                    <InputBox title={"Final Amount"}>
                        <input
                            className="form-control"
                            value={orderData.finalAmount}
                            disabled
                            style={{fontWeight: 'bold', backgroundColor: '#f5f5f5'}}
                        />
                    </InputBox>
                </div>

                {/* Payment Methods - Same as PosComponent */}
                <InputBox title={"Payment Methods"}>
                    <div className="d-flex align-items-center">
                        <select
                            className="form-control me-2"
                            value={selectedPaymentType}
                            onChange={(e) => setSelectedPaymentType(e.target.value)}
                            style={{width: "200px"}}
                        >
                            <option value="">Select Payment</option>
                            {!selectedPaymentInputs.includes("cash") && (
                                <option value="cash">Cash</option>
                            )}
                            {!selectedPaymentInputs.includes("upi") && (
                                <option value="upi">UPI</option>
                            )}
                            {!selectedPaymentInputs.includes("card") && (
                                <option value="card">Card</option>
                            )}
                        </select>

                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => {
                                if (!selectedPaymentType) {
                                    notification.warning({message: "Select payment method"});
                                    return;
                                }
                                handlePaymentOptionToggle(selectedPaymentType);
                                setSelectedPaymentType("");
                            }}
                        >
                            +
                        </button>
                    </div>
                </InputBox>

                {/* Dynamic Payment Inputs */}
                <div className={"row"}>
                    {selectedPaymentInputs.includes("cash") && (
                        <div className={"col-md-12 mb-3"}>
                            <InputBox title={"CASH"}>
                                <input
                                    value={newPaymentData.cashAmount || ""}
                                    className={"form-control"}
                                    type={"number"}
                                    onChange={(e) => handlePaymentInputChange("cash", e.target.value)}
                                />
                            </InputBox>
                        </div>
                    )}

                    {selectedPaymentInputs.includes("upi") && (
                        <div className={"col-md-12 mb-3"}>
                            <InputBox title={"UPI"}>
                                <input
                                    value={newPaymentData.upiAmount || ""}
                                    className={"form-control"}
                                    type={"number"}
                                    onChange={(e) => handlePaymentInputChange("upi", e.target.value)}
                                />
                            </InputBox>
                        </div>
                    )}

                    {selectedPaymentInputs.includes("card") && (
                        <div className={"col-md-12 mb-3"}>
                            <InputBox title={"CARD"}>
                                <input
                                    value={newPaymentData.cardAmount || ""}
                                    className={"form-control"}
                                    type={"number"}
                                    onChange={(e) => handlePaymentInputChange("card", e.target.value)}
                                />
                            </InputBox>
                        </div>
                    )}
                </div>

                {/* Customer Paid - Shows NEW total only */}
                <InputBox title={"Customer Paid"}>
                    <input
                        value={(Number(newPaymentData.cashAmount || 0) + Number(newPaymentData.upiAmount || 0) + Number(newPaymentData.cardAmount || 0)).toFixed(2)}
                        className={"form-control"}
                        type={"text"}
                        disabled={true}
                        style={{fontWeight: 'bold', backgroundColor: '#e8f5e9'}}
                    />
                </InputBox>

                {/* Buttons */}
                <div className="mt-3 d-md-flex justify-content-md-end">
                    <button
                        className="btn btn-danger"
                        onClick={() => {
                            setIsEditOrderModalOpen(false);
                            setSelectedPaymentInputs([]);
                            setManualPaymentInputs([]);
                            setSelectedPaymentType("");
                            setNewPaymentData({cashAmount: 0, upiAmount: 0, cardAmount: 0});
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={editOrder}
                        className="btn btn-success ms-2"
                    >
                        Update Payment
                    </button>
                </div>
            </Modal>
        )}
        {editKotModal && (<Modal
            visible={editKotModal}
            onClose={() => {
                setEditKotModal(false);
            }}
            title={"Edit Kot"}
        >
            <div className={"mt-2"}>
                {editKotProducts && editKotProducts.map((product) => {
                    return (<>
                        <ul
                            className="product-lists mb-0 p-1"
                            key={product._id}
                        >
                            <li className="w-50">
                                <div className="productimg">
                                    <div className="productcontet">
                                        <h6 className={"mb-0"}>
                                            {product && product.productId && product.productId.vegNonVeg ? (<>
                                                {getVegStatus(product.productId.vegNonVeg)}
                                            </>) : ("")}
                                            {product.name}{" "}
                                            {product.variant && ` (${product.variant})`}
                                        </h6>
                                    </div>
                                </div>
                            </li>

                            <li>
                                <div className="increment-decrement">
                                    <div className="input-groups">
                                        <input
                                            type="button"
                                            value="-"
                                            onClick={() => {
                                                events.desEditcQty(product);
                                            }}
                                            className="button-minus dec button"
                                        />
                                        <input
                                            type="text"
                                            name="child"
                                            value={product.quantity}
                                            className="quantity-field"
                                        />
                                        <input
                                            type="button"
                                            value="+"
                                            onClick={() => {
                                                events.incEditQty(product);
                                            }}
                                            className="button-plus inc button "
                                        />
                                    </div>
                                </div>
                            </li>
                            <li>
                                              <span
                                                  style={{
                                                      fontSize: "80%",
                                                  }}
                                              >
                                                Rs. {product.price}
                                              </span>
                            </li>
                            <li>
                                <strong>
                                    Rs. {product.totalAmount}
                                </strong>
                            </li>
                            {/* <li>
                                {userType === "admin" && (
                                    <Popconfirm
                                        title="Are you sure you want to remove this item?"
                                        onConfirm={() => removeSingleProduct(product)}
                                        okText="Yes"
                                        cancelText="No">
                                        <a className="empty_btn danger">
                                            <i className="fa fa-trash"/>
                                        </a>
                                    </Popconfirm>
                                )}
                            </li>*/}
                        </ul>
                    </>);
                })}

                <div className="d-flex justify-content-end mt-2">
                    {/*<button*/}
                    {/*    onClick={() => {*/}
                    {/*        handleEditkot(editKotProducts, "kot");*/}
                    {/*    }}*/}
                    {/*    className="btn btn-success"*/}
                    {/*>*/}
                    {/*    Save*/}
                    {/*</button>*/}
                    <div className="d-flex justify-content-end mt-2">
                        {/*<button*/}
                        {/*    type="button"*/}
                        {/*    className="btn btn-danger me-2"*/}
                        {/*    onClick={removeAllProductsFromKot}*/}
                        {/*>*/}
                        {/*    Remove All*/}
                        {/*</button>*/}
                        {/*{userType === "admin" && (*/}
                        {/*    <button*/}
                        {/*        type="button"*/}
                        {/*        className="btn btn-danger me-2"*/}
                        {/*        onClick={removeAllProductsFromKot}*/}
                        {/*    >*/}
                        {/*        Remove All*/}
                        {/*    </button>*/}


                        <button
                            onClick={() => {
                                handleEditkot(editKotProducts, "kot");
                            }}
                            className="btn btn-success"
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </Modal>)}

        {/*<div style={{display: "none"}}>*/}
        {/*    {singleOrderData && singleOrderData._id ? (*/}
        {/*        <PrintDesign ref={componentRef} singleOrderData={singleOrderData}/>) : null}*/}
        {/*</div>*/}

        <div style={{display: "none"}}>
            {singleOrderData && singleOrderData._id ? (
                <PrintDesign
                    ref={componentRef}
                    singleOrderData={singleOrderData}
                    isDuplicateBill={true}
                />
            ) : null}
        </div>

        {updateCustomerDrawer.visible ? (
            <Drawer
                placement="right"
                onClose={closeUpdateCustomerDrawer}
                visible={updateCustomerDrawer.visible}
                width={600}
                title={"Update Customer"}>
                <div className="row">
                    <div className="col-md-12">
                        <InputBox title={"Customer Name"}>
                            <input
                                className="form-control"
                                value={updateCustomerForm.customerName}
                                onChange={(e) =>
                                    setUpdateCustomerForm({
                                        ...updateCustomerForm,
                                        customerName: e.target.value,
                                    })
                                }
                                placeholder="Enter customer name"
                            />
                        </InputBox>
                    </div>

                    <div className="col-md-12">
                        <InputBox title={"Mobile Number"}>
                            <input
                                className="form-control"
                                value={updateCustomerForm.customerMobile}
                                onChange={(e) =>
                                    setUpdateCustomerForm({
                                        ...updateCustomerForm,
                                        customerMobile: e.target.value,
                                    })
                                }
                                placeholder="Enter mobile number"
                            />
                        </InputBox>
                    </div>

                    <div className="col-md-12">
                        <InputBox title={"Email"}>
                            <input
                                className="form-control"
                                value={updateCustomerForm.customerEmail}
                                onChange={(e) =>
                                    setUpdateCustomerForm({
                                        ...updateCustomerForm,
                                        customerEmail: e.target.value,
                                    })
                                }
                                placeholder="Enter email"
                            />
                        </InputBox>
                    </div>

                    <div className="col-md-12">
                        <InputBox title={"GST No"}>
                            <input
                                className="form-control"
                                value={updateCustomerForm.customerGst}
                                onChange={(e) =>
                                    setUpdateCustomerForm({
                                        ...updateCustomerForm,
                                        customerGst: e.target.value,
                                    })
                                }
                                placeholder="Enter GST number"
                            />
                        </InputBox>
                    </div>

                    <div className="col-md-12 mt-3 text-end">
                        <button className="btn btn-info" onClick={handleUpdateCustomerSubmit}>
                            Update Customer Details
                        </button>
                    </div>
                </div>
            </Drawer>
        ) : null}


        {fullEditState.visible ? (
            <Modal
                visible={fullEditState.visible}
                onClose={() => {
                    setFullEditState({
                        orderId: "",
                        visible: false
                    })
                }}
                title={`Edit Order ( Order No. - ${orderNumber} )`}>
                <div className={'d-flex flex-wrap'}>
                    {[
                        {title: "Total Amount", field: "totalAmount"},
                        {title: "Discount Amount", field: "discount"},
                        {title: "CGST Amount", field: "cgstAmount"},
                        {title: "SGST Amount", field: "sgstAmount"},
                        {title: "Service Charges", field: "serviceTaxAmount"},
                        {title: "Net Amount", field: "netAmount"},
                        {title: "Cash Discount", field: "cashDiscount"},
                        {title: "Final Amount", field: "finalAmount"},
                        {title: "Customer Paid", field: "customerPaid"},
                        {title: "Cash Amount", field: "cashAmount"},
                        {title: "UPI Amount", field: "upiAmount"},
                        {title: "Card Amount", field: "cardAmount"}
                    ].map((input) => (
                        <div className={'d-flex col-md-6'} key={input.field}>
                            <InputBox title={input.title}>
                                <input
                                    style={{width: '350px'}}
                                    value={orderData[input.field]}
                                    className={"form-control"}
                                    type={"number"}
                                    onChange={(e) => {
                                        setOrderData({
                                            ...orderData,
                                            [input.field]: e.target.value,
                                        });
                                    }}
                                />
                            </InputBox>
                        </div>
                    ))}
                </div>
                <div className="text-center mt-3">
                    <button className="btn btn-info" onClick={handleSubmitFullEdit}>
                        Submit
                    </button>
                </div>
            </Modal>
        ) : null}


    </PageHeader>);
}

export default OrderList;




